/* PetPivot product grid: category filters, sorting and anchor-nav highlighting.
   Scoped per section so several instances can live on one page. */
(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function matchesCategory(card, value) {
    if (!value || value === 'all') return true;
    if (card.getAttribute('data-category') === value) return true;
    var tags = (card.getAttribute('data-tags') || '').split(' ');
    return tags.indexOf(value) !== -1;
  }

  function initAnchorNav(root) {
    var navLinks = toArray(root.querySelectorAll('.pp-anchor-nav a'));
    if (!navLinks.length || !('IntersectionObserver' in window)) return;
    var targets = navLinks
      .map(function (link) {
        var href = link.getAttribute('href') || '';
        return href.charAt(0) === '#' && href.length > 1 ? document.getElementById(href.slice(1)) : null;
      })
      .filter(Boolean);
    if (!targets.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        navLinks.forEach(function (link) {
          link.classList.toggle('is-current', link.getAttribute('href') === '#' + entry.target.id);
        });
      });
    }, { rootMargin: '-25% 0px -65% 0px' });
    targets.forEach(function (target) { observer.observe(target); });
  }

  function initGrid(root) {
    if (root.getAttribute('data-pp-ready') === 'true') return;
    root.setAttribute('data-pp-ready', 'true');

    if (root.getAttribute('data-pp-anchor-nav-only') === 'true') {
      initAnchorNav(root);
      return;
    }

    var grid = root.querySelector('[data-pp-grid]');
    var filters = toArray(root.querySelectorAll('[data-filter]'));
    var sort = root.querySelector('[data-pp-sort]');
    var count = root.querySelector('[data-pp-count]');
    var cards = grid ? toArray(grid.querySelectorAll('.pp-product-card')) : [];

    /* Counts are computed from the rendered products so they stay correct
       whichever collection the merchant selects. */
    filters.forEach(function (button) {
      var value = button.getAttribute('data-filter');
      var total = cards.filter(function (card) { return matchesCategory(card, value); }).length;
      var badge = button.querySelector('span');
      if (badge) badge.textContent = String(total);
      if (total === 0 && value !== 'all') button.hidden = true;
    });

    function update() {
      if (!grid) return;
      var active = root.querySelector('[data-filter].is-active');
      var category = active ? active.getAttribute('data-filter') : 'all';
      cards.forEach(function (card) {
        card.hidden = !matchesCategory(card, category);
      });
      if (count) {
        count.textContent = String(cards.filter(function (card) { return !card.hidden; }).length);
      }
      var mode = sort ? sort.value : 'featured';
      cards
        .slice()
        .sort(function (a, b) {
          if (mode === 'alphabetical') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
          if (mode === 'price-low') return Number(a.getAttribute('data-price')) - Number(b.getAttribute('data-price'));
          if (mode === 'price-high') return Number(b.getAttribute('data-price')) - Number(a.getAttribute('data-price'));
          return Number(a.getAttribute('data-position')) - Number(b.getAttribute('data-position'));
        })
        .forEach(function (card) { grid.appendChild(card); });
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        filters.forEach(function (item) { item.classList.remove('is-active'); });
        button.classList.add('is-active');
        update();
      });
    });
    if (sort) sort.addEventListener('change', update);

    update();
    initAnchorNav(root);
  }

  function initAll(scope) {
    toArray((scope || document).querySelectorAll('[data-pp-product-grid]')).forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-initialise when a section is added or re-rendered. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
